import { jsx, jsxs } from "react/jsx-runtime";
import { Loader } from "../../../../../components/loader/loader.js";
import { Button } from "../../utils/shared/Button.js";
import { Content } from "./submit-button.styles.js";
import "../../../../../components/loader/data.js";
import "../../../../../components/animation/animation.js";
import "lottie-react";
import "../../../../../components/loader/loader.styles.js";
import "@mui/material";
import "@mui/system";
const SubmitButton = ({ children, loading, ...props }) => /* @__PURE__ */ jsx(Button, { fullWidth: true, ...props, disabled: loading || props.disabled, children: /* @__PURE__ */ jsxs(Content, { children: [
  children,
  loading && /* @__PURE__ */ jsx(Loader, { size: "xs" })
] }) });
export {
  SubmitButton
};
